import PropTypes from 'prop-types'
import styles from './fechaSelect.module.css'

export const FechaSelect = ({
  label,
  claveFecha,
  errorFecha,
  fecha,
  guardarFecha,
  errorMensaje,
  isSelected,
  disabled
}) => {
  return (
    <div className={styles.fechaContainer}>
      <label htmlFor={`fecha-${claveFecha || label}`}>{`Fecha de ${label}`}</label>
      <input
        type="date"
        id={`fecha-${claveFecha || label}`}
        className={errorFecha ? styles.inputError : ''}
        value={fecha ?? ''}
        onChange={(e) => guardarFecha(e.target.value, claveFecha || label)}
        disabled={disabled}
      />
      {isSelected && (
        <button
          className={styles.closeBtn}
          aria-label="Limpiar fecha"
          onClick={(e) => {
            e.stopPropagation()
            guardarFecha('')
          }}
        >
          ✕
        </button>
      )}
      {errorFecha && (
        <span className={styles.mensajeError}>{errorMensaje || 'La fecha no es válida.'}</span>
      )}
    </div>
  )
}

FechaSelect.propTypes = {
  label: PropTypes.string.isRequired,
  claveFecha: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  errorFecha: PropTypes.bool,
  fecha: PropTypes.string,
  guardarFecha: PropTypes.func.isRequired,
  errorMensaje: PropTypes.string,
  isSelected: PropTypes.bool,
  disabled: PropTypes.bool
}
